import { useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '@/utils/api';

const useAnalytics = () => {
  useEffect(() => {
    // Track page view
    const trackPageView = async () => {
      try {
        // Detect device type
        const deviceType = /Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) 
          ? 'mobile' 
          : 'desktop';

        // Get current page URL (path only, not full URL for privacy)
        const pageUrl = window.location.pathname;
        
        // Get referrer
        const referrer = document.referrer || null;

        // Send analytics data (non-blocking, fire and forget)
        axios.post(`${API_URL}/analytics/track`, {
          page_url: pageUrl,
          referrer: referrer,
          device_type: deviceType,
          user_agent: navigator.userAgent
        }).catch(err => {
          // Silently fail - don't impact user experience
          console.debug('Analytics tracking failed:', err);
        });
      } catch (error) {
        // Silently fail
        console.debug('Analytics error:', error);
      }
    };

    // Track after a small delay to not block initial render
    const timeoutId = setTimeout(trackPageView, 100);

    return () => clearTimeout(timeoutId);
  }, []);
};

export default useAnalytics;
